<template>
    <div class="swiperCon">
        <swiper :options="swiperOption" class="a" v-if="slideList.length>0">
            <swiper-slide v-for="(item, index) in slideList" :key="index" :data-bookid="item.book">
                <img :src="item.image" alt="">
            </swiper-slide>
            <div class="swiper-pagination" slot="pagination"></div>
            <div class="swiper-button-prev" slot="button-prev"></div>
            <div class="swiper-button-next" slot="button-next"></div>
        </swiper>
    </div>
</template>

<script>
let vm = null;
export default {
    data() {
        return {
            swiperOption: {
                loop: true,
                navigation: {
                    nextEl: '.swiper-button-next',
                    prevEl: '.swiper-button-prev'
                },
                pagination: {
                    el: '.swiper-pagination'
                },
                autoplay: {
                    delay: 3000,
                    stopOnLastSlide: false,
                    disableOnInteraction: false,
                },
                on: {
                    click: function(swiper) {
                        if( this.clickedSlide ) {
                            var bookId = this.clickedSlide.getAttribute('data-bookid');
                            vm.goBook(bookId);
                        }
                    }
                },
            },
            slideList: [],
        }
    },
    computed: {

    },
    mounted() {
        vm = this;
        let that = this;
        that.homeSlide();
    },
    methods: {
        homeSlide() {
            let that = this;
            that.allApi.slideList().then((resource) => {
                if( resource.data.code == 200 ) {
                    that.slideList = resource.data.data;
                }
            })
        },
        goBook(bookId) {
            let that = this;
            that.addClickNum(bookId);
            that.$router.push({
                path: '/book',
                query: {
                    id: bookId
                }
            })
        },
        addClickNum(bookId) {
            let that = this;
            let data = {
                book: bookId
            }
            that.allApi.bookClick(data).then((resource) => {
                if( resource.data.code == 200 ) {
                    
                }
            })
        }
    }
}
</script>

<style lang="scss" scoped>
    .swiperCon{
        width: 1200px;
        margin: 0 auto 38px;
        height: 432px;
        >.a{
            height: 432px;
            .swiper-slide{
                cursor: pointer;
                >img{
                    display: block;
                    width: 100%;
                    height: 100%;
                }
            }
            .swiper-pagination{
                text-align: right;
                padding-right: 50px;
            }
        }
    }
</style>
